import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'

interface exportUsersProps {
  setIsExportUsersRequestRunning: Function
}

const exportUsers = async (props: exportUsersProps) => {
  let response: any = false
  props.setIsExportUsersRequestRunning(true)
  response = await axiosGet(apiUrls.users + '/' + apiUrls.actionExport, {}, () => {}, {
    responseType: 'blob',
  }).then(async (response) => {
    props.setIsExportUsersRequestRunning(false)

    if (response === undefined) {
      return
    }
    const retText: any = await response?.data?.text()
    if (response.status === 200) {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data)
      // create "a" HTML element with href to file & click
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'export-users.csv')
      document.body.appendChild(link)
      link.click()

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    }
    return response
  })

  return response
}

export default exportUsers
